import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  personlaInfoCard = signal(false);
  downloadingPDF = signal(false);
  sidebarVisible = signal(true);
  notificationDrawerVisible = signal(false);
  copilotDrawerVisible = signal(false);
  lastNonCopilotRoute = signal<string>('/main/dashboard');

  curentComponentTitle = signal('');

  rangeDates = signal<Date[] | undefined>([
    new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0),
    new Date(new Date().setHours(23, 59, 59, 999)),
  ]);
}
